import React, { Component } from 'react';
import RoleComponent from '../../components/Role/RoleComponent';
class Role extends Component {
    render() {
        return (
            <div>
                <RoleComponent />
            </div>
        );
    }
}

export default Role;